<template>
  <div v-if="clientPortal != null" id="show-migrate-client-portal-builtin">
    <v-card flat>
      <v-card-title> </v-card-title>
      <v-card-text>
        <div>
          <v-dialog v-model="dialogForMigrateClient" persistent>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                color="primary"
                style="max-width: 100%"
                :disabled="
                  isClientPortalMigrableParent != null &&
                  (isClientPortalMigrableParent.facebook ||
                    isClientPortalMigrableParent.pms)
                "
              >
                <span v-if="$vuetify.breakpoint.width >= 800">
                  Migrer le portail avec un Template prédéfini en V5</span
                >
                <span
                  v-if="
                    $vuetify.breakpoint.width > 600 &&
                    $vuetify.breakpoint.width < 800
                  "
                  >Migrer avec un Template prédéfini en V5</span
                >
                <span v-if="$vuetify.breakpoint.width <= 600"
                  >Migrer vers la V5</span
                >
              </v-btn>
              <p
                v-if="
                  isClientPortalMigrableParent != null &&
                  isClientPortalMigrableParent.facebook
                "
              >
                Le portail est configuré avec Facebook, option non supportée sur
                les V5.
              </p>
              <p
                v-if="
                  isClientPortalMigrableParent != null &&
                  isClientPortalMigrableParent.pms
                "
              >
                Le portail est configuré avec la PMS, option non supportée sur
                les V5.
              </p>
            </template>
            <v-card>
              <v-card-title> </v-card-title>
              <v-card-text>
                <v-form>
                  Actuellement le Template utilisé est:
                  <b>{{ clientPortal.portalOptions.name }}</b>

                  <v-select
                    v-model="portalProfile"
                    label="Liste des templates définis"
                    :items="portalProfiles"
                    item-value="id"
                    item-text="name"
                  >
                  </v-select>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="dialogForMigrateClient = false"
                  >Fermer</v-btn
                >
                <v-btn
                  color="blue darken-1"
                  text
                  @click="
                    [
                      migrateClientPortal(clientPortal.id, portalProfile),
                      (dialogForMigrateClient = false),
                    ]
                  "
                  >Migrer le portail</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import { onMounted, ref, toRefs } from "@vue/composition-api";
import { useMigrationPortal } from "../../composables/migation-portal";
import { usePortalProfile } from "../../composables/portal-profile";

export default {
  props: {
    clientPortal: Object,
    isClientPortalMigrableParent: Object,
  },
  setup(props) {
    const { migrationPortalData, migrateClientPortal } = useMigrationPortal();
    const { portalProfiles, listPortalProfileV5 } = usePortalProfile();
    onMounted(() => {
      listPortalProfileV5(props.clientPortal.partner.id);
    });

    return {
      migrateClientPortal,
      dialogForMigrateClient: ref(false),
      ...toRefs(migrationPortalData),
      portalProfiles,
      portalProfile: ref(null),
    };
  },
};
</script>
